export default __webpack_public_path__ + "static/media/award-center.8b03bcc3.png";